/**
 * Fields stored in SQL (Project.scoping_profile_json).
 * Keep in sync with backend merge expectations and persist call sites.
 *
 * MUST NEVER include "approvedDocumentLibraryPackage" (backlog #20 / Stage 10 "Approved
 * document library", workflow-doc slide 14). The backend's
 * assertApprovedDocumentLibraryPublishSaveAllowed() deliberately 403s any generic
 * `PUT /projects/:id/profile` call carrying that key, because a raw JSON merge can't
 * correctly append to the package's history[] array or fire the right audit actions
 * (Commandment VI/VII). That package is written only via the dedicated
 * `POST /projects/:id/approved-document-library/publish-state` endpoint. If this key is
 * ever added here, every routine profile save that echoes the field back will silently
 * start 403ing — see pickScopingPersistPayload.test.js for the regression guard.
 */
export function pickScopingPersistPayload(profile) {
  if (!profile || typeof profile !== "object") return {};
  const keys = [
    "workspaceActiveStep",
    "profilingSubTab",
    "scopingWizard",
    "scopingControlAnalysis",
    "scopingActiveSubTab",
    "scopingContractDraft",
    "scopingContractAnnotations",
    "scopingContractAppendSections",
    "profilingDocumentDraft",
    "gapAnalysisQuestionnaire",
    "gapQuestionnaireDocument",
    "issuesThreatsOpportunities",
    "projectOnboardingWizard",
    "riskOnboarding",
    "raci",
    "resources",
    "scoping",
    "milestones",
    "priceEstimate",
    "paymentTranches",
    "pricingDisplayCurrency",
    "inrPerUsd",
    "evidence",
    "evidenceFileArtifacts",
    "comments",
    "gapAnalysisWizard",
    "gapAnalysisStatus",
    "organizationalSetupWizard",
    "complianceRegisterPackage",
    "riskRegisterPackage",
    "riskTreatmentPackage",
    "statementOfApplicabilityPackage",
    "controlImplementationPackage",
    "documentLibrary",
    "internalAuditPackage",
    "incidentMonitoringPackage",
    "companyLogo",
    "companyColorPalette",
    "companyFont",
  ];
  const o = {};
  for (const k of keys) {
    // A null FX rate means "unavailable"; never persist it as if it were a rate.
    if (k === "inrPerUsd" && profile[k] == null) continue;
    if (profile[k] !== undefined) o[k] = profile[k];
  }
  return o;
}
